import ReportsPageList from './reportsPageList';

export default ReportsPageList;
